import { useLocation } from 'react-router'
import { EventProvider } from './components/event'
import { FacilityProvider } from './components/Facility'
import { OnTheGoProvider } from './components/onTheGo'
import { TemplateProvider } from './components/template/TemplateProvider'

export function ResourceProvider({ children }: { children: any }) {
  const location = useLocation()
  const isEventPage = location.pathname.includes('/events')
  const isFacilityPage = location.pathname.includes('/facilities')
  const isOnTheGoPage = location.pathname.includes('/onTheGo')
  const isTemplatePage = location.pathname.includes('/templates')

  if (isEventPage) return <EventProvider>{children}</EventProvider>

  if (isFacilityPage) return <FacilityProvider>{children}</FacilityProvider>

  if (isOnTheGoPage) return <OnTheGoProvider>{children}</OnTheGoProvider>

  if (isTemplatePage) return <TemplateProvider>{children}</TemplateProvider>

  return <>{children}</>
}
